import { Component, Input, OnInit } from '@angular/core';
import { Link } from '../../interfaces/link';

@Component({
  selector: 'app-links-grid',
  templateUrl: './links-grid.component.html',
  styleUrls: ['./links-grid.component.scss']
})
export class LinksGridComponent implements OnInit {
  @Input() links: Link[];

  constructor() { }

  ngOnInit() {
  }

}
